import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { LinkModule } from "@lantern/app/common/link";

import { AuthDirectivesModule } from "./auth";
import { DetailPageComponentModule } from "./detail-page";
import { LanternFormsModule } from "./forms";
import { NavigationModule } from "./navigation";
import { PipesModule } from "./pipes";
import { TestTagModule } from "./test-tag";
import { LanternUtilsModule } from "./utils";
import { ExpContainerModule } from "./wayfarer/container/exp-container.module";

@NgModule({
  imports: [],
  declarations: [],
  exports: [
    AuthDirectivesModule,
    CommonModule,
    DetailPageComponentModule,
    LanternFormsModule,
    LanternUtilsModule,
    LinkModule,
    NavigationModule,
    PipesModule,
    TestTagModule,
    ExpContainerModule
  ]
})
export class LanternCommonModule {}
